const SANITIZE_TRACKED_URLS = true;

const SENSITIVE_QUERY_PARAMS = [
  "code",
  "error",
  "fromUrl",
  "mode",
  "navigate",
  "seed_session",
  "switchToInitiative"
];


const DEDUPE_WINDOW_MS = 500;

type VirtualPageViewPush = {
  event: "virtual_page_view"
  full_page_url: string
  mtm_event_timestamp: string
  page_hostname: string
  page_path: string
  page_title: string
  page_url_no_query: string
  previous_page_url: string
}


let previousPageUrl = typeof document !== "undefined" ? document.referrer : "";
let lastTrackedUrl = "";
let lastTrackedAt = 0;

function getDataLayer(): unknown[] {
  const w = window as unknown as { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer || [];
  return w.dataLayer;
}


function normalizeLabel(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, "_");
}


function localIsoTimestamp(): string {
  const now = new Date();
  const pad = (n: number, length = 2) => String(Math.abs(n)).padStart(length, "0");
  const offsetMinutes = -now.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? "+" : "-";
  const offset = `${sign}${pad(Math.trunc(Math.abs(offsetMinutes) / 60))}:${pad(Math.abs(offsetMinutes) % 60)}`;
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
    + `T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
    + `.${pad(now.getMilliseconds(), 3)}${offset}`;
}


function sanitizeUrl(href: string): string {
  if (!SANITIZE_TRACKED_URLS || !href) return href;
  try {
    const url = new URL(href);
    SENSITIVE_QUERY_PARAMS.forEach((param) => url.searchParams.delete(param));
    return url.toString();
  } catch {
    return href;
  }
}

function pushVirtualPageView(fullUrl: string, path: string, title: string): void {
  const now = Date.now();
  if (fullUrl === lastTrackedUrl && now - lastTrackedAt < DEDUPE_WINDOW_MS) return;

  let urlNoQuery = fullUrl;
  let hostname = typeof window !== "undefined" ? window.location.hostname : "";
  try {
    const url = new URL(fullUrl);
    urlNoQuery = `${url.origin}${url.pathname}`;
    hostname = url.hostname;
  } catch { /* URL non parsabile  */ }

  const push: VirtualPageViewPush = {
    event: "virtual_page_view",
    full_page_url: fullUrl,
    mtm_event_timestamp: localIsoTimestamp(),
    page_hostname: hostname,
    page_path: path,
    page_title: normalizeLabel(title),
    page_url_no_query: urlNoQuery,
    previous_page_url: previousPageUrl
  };
  getDataLayer().push(push);

  previousPageUrl = fullUrl;
  lastTrackedUrl = fullUrl;
  lastTrackedAt = now;
}


export function trackVirtualPageView({ title }: { title?: string } = {}): void {
  if (typeof window === "undefined") return;
  const fullUrl = sanitizeUrl(window.location.href);
  const path = window.location.pathname;
  pushVirtualPageView(fullUrl, path, title || document.title || "");
}


export function trackOverlayView(overlayName: string): void {
  if (typeof window === "undefined" || !overlayName) return;
  const slug = normalizeLabel(overlayName);
  const base = sanitizeUrl(window.location.href).split("#")[0];
  const fullUrl = `${base}#${slug}`;
  const path = `${window.location.pathname}#${slug}`;
  pushVirtualPageView(fullUrl, path, slug);
}
